import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Lock } from '../models/lock';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs/observable/of';
import { getFileNameFromResponseContentDisposition, checkIfTruncated, saveFile } from './utils/file-download-helper';

@Injectable()
export class LockService {

  LOCK_API_URL = environment.serverUrl + 'api/1/locks';

  constructor(private httpClient: HttpClient) { }

  getFormattedUrl(pageIndex: number, itemPerPage: number, filters: Map<string, any>, criterias: Map<string, boolean>, bikeLink : BikeLink) {
    let offset = ((pageIndex - 1) * itemPerPage); // records offset to display the specific range
    let url = this.LOCK_API_URL + "?pagination=" + offset + "-" + itemPerPage + "&sorts=";

    if (criterias.size == 0) { // if no sorts criterias => sort by id
      url += "l.id asc";
    } else {
      Array.from(criterias.keys()).forEach(c => url += c + (criterias.get(c) === true ? " asc" : " desc") + ",");
      url = url.substring(0, url.length - 1);
    }

    if (filters != undefined) {

      let filtersAsString = JSON.stringify(filters, (key, value) => {
        if (value !== null && value != undefined && value != "") return value
      });

      if (filtersAsString.length > 2) {
        url += "&filters=" + filtersAsString;
      }
    }

    url += "&bikeLink=" + BikeLink[bikeLink];

    return url;
  }

  getPaginatedFilteredSortedLocks(pageIndex: number, itemPerPage: number, filters: Map<string, any>, criterias: Map<string, boolean>, bikeLink : BikeLink): Observable<any> {
    let url = this.getFormattedUrl(pageIndex, itemPerPage, filters, criterias, bikeLink);

    return this.httpClient.get<any>(encodeURI(url), { observe: "response" }).map(response => {
      return {
        headers: response.headers,
        res: <Lock[]>response.body
      }
    });
  }

  downloadXLSFile(pageIndex: number, itemPerPage: number, filters: Map<string, any>, criterias: Map<string, boolean>, bikeLink : BikeLink): any {
    let url = this.getFormattedUrl(pageIndex, itemPerPage, filters, criterias, bikeLink);
    return this.httpClient.get<any>(encodeURI(url), {
      headers: { Accept: 'application/octet-stream' },
      responseType: 'blob' as 'json',
      observe: 'response'
    }).map((response) => {
      const fileName = getFileNameFromResponseContentDisposition(response, "locks.xls");
      const isTruncated = checkIfTruncated(response);
      saveFile(response.body.slice(), fileName);
      return isTruncated;
    });
  }

  delete(l : Lock) {
    return this.httpClient.delete(encodeURI(this.LOCK_API_URL + "/" + l.id));
  }

  get(l : Lock) : Observable<Lock> {
    return this.httpClient.get<Lock>(encodeURI(this.LOCK_API_URL + "/" + l.id));
  }

  post(l : Lock) : Observable<Lock> {
    return this.httpClient.post<Lock>(this.LOCK_API_URL, l);
  }

  put(l : Lock) : Observable<Lock> {
    return this.httpClient.put<Lock>(this.LOCK_API_URL + "/" + l.id, l);
  }

  getFreeLockByGroupAndType(groupId : number, type : string) : Observable<any> {
    let url = this.LOCK_API_URL + "?pagination=0-100&sorts=l.id asc&filters={\"l.type\":\"" + type + "\"}&groupId=" + groupId
                                + "&bikeLink=" + BikeLink[BikeLink.ONLY_NULLS] ; 
    return this.httpClient.get<any>(encodeURI(url), {observe:"response"}).map(response => {
      return {
        headers: response.headers,
        res: <Lock[]>response.body
      }
    });
  }

}

export enum BikeLink {
  ALL, ONLY_NULLS, ONLY_LINKED
}


// WEBPACK FOOTER //
// ./src/app/services/lock.service.ts